import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';

import { configGetSettings } from 'common/helper/config/get-settings';
import { BuildingReviewLandingBundleSettingsInterface } from 'common/module/building-review-landing/bundle-settings.interface';
import { BuildingReviewLandingCssSelectorEnum } from 'common/module/building-review-landing/css-selector.enum';
import { AbTestService } from 'common/service/ab-test/service';
import { FooterService } from 'common/service/footer/service';
import { HeaderService } from 'common/service/header/service';
import { LanguageSelectorService } from 'common/service/language-selector/service';
import { LocationStoreService } from 'common/service/location-store/service';
import { PrivacyPromptService } from 'common/service/privacy-prompt/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { BuildingReviewLandingViewFactory } from 'desktop/module/building-review-landing/view.factory';
import { UserAvatarComponent } from 'desktop/module/user/avatar/component';

AbTestService().initialize();

const bundleSettings = configGetSettings<BuildingReviewLandingBundleSettingsInterface>();

// Common services
HeaderService()
  .setComponents({
    UserAvatarComponent,
  })
  .render();
UserAuthenticationService();
FooterService();

LanguageSelectorService();
LocationStoreService().initialize({
  payload: bundleSettings.locations,
});

PrivacyPromptService();

const view = BuildingReviewLandingViewFactory();

view.initialize({
  element: domQuerySelector(document.body, BuildingReviewLandingCssSelectorEnum.page),
});

view.render();
